import { createContext } from "react"
import useGetClientAppSettings from "../../hooks/data/useGetClientAppSettings";

export interface IAppSettingsContext extends ReturnType<typeof useGetClientAppSettings> {
}

export const AppSettingsContext = createContext<IAppSettingsContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default AppSettingsContext;